import { render, staticRenderFns } from "./TipoInstituicoes.vue?vue&type=template&id=58dddbb4"
import script from "./TipoInstituicoes.vue?vue&type=script&lang=js"
export * from "./TipoInstituicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports